import React from 'react';
import AppBannerLayout from 'modules/partial/BannerLayout';
import { Route, Switch, useLocation, useRouteMatch } from 'react-router-dom';
import Residence from './resident/Resident';
import Personal from './personal/Personal';
import Address from './address/Address';
import TakePhoto from './photo/TakePhoto';
import ReviewDetails from './review-details';

function Register() {
  const { path } = useRouteMatch();
  const { pathname } = useLocation();

  return (
    <AppBannerLayout>
      <div className="flex flex-col justify-center">
        <div className="space-y-6 my-12">
          <h4 className="text-lg text-primary-500 font-semibold">
            {pathname === '/register/review-details'
              ? 'Review and Submit'
              : 'Registration'}
          </h4>
          <Switch>
            <Route path={`${path}/personal`} component={Personal} />
            <Route path={`${path}/address`} component={Address} />
            <Route path={`${path}/take-photo`} component={TakePhoto} />
            <Route path={`${path}/review-details`} component={ReviewDetails} />
            <Route path={`${path}`} component={Residence} />
          </Switch>
        </div>
      </div>
    </AppBannerLayout>
  );
}
Register.defaultProps = {};

Register.propTypes = {};

export default Register;
